// extracted by mini-css-extract-plugin
export default {"photos":"Photos-module--photos--db6da","row":"Photos-module--row--5c7d1","photo":"Photos-module--photo--8a700","more":"Photos-module--more--4d597"};